import APIClient from './index';

// Row endpoints
export const getRecommendationsPreview = params => {
  return new Promise((resolve, reject) => {
    APIClient.get(`RecommendationRows/preview`, { params })
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const getRecommendationRows = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('RecommendationRows')
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const createRecommendationRow = data => {
  return new Promise((resolve, reject) => {
    APIClient.post('RecommendationRows', data)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const updateRecommendationRow = (id, data) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`RecommendationRows/${id}`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const deleteRecommendationRow = id => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`RecommendationRows/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

// Grid endpoints
export const getRecommendationGrids = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('RecommendationGrids')
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const getRecommendationGrid = id => {
  return new Promise((resolve, reject) => {
    APIClient.get(`RecommendationGrids/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const getRecommendationGridPreview = (idOrSlug, params) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`RecommendationGrids/${idOrSlug}`, { params })
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const updateRecommendationGrid = (id, data) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`RecommendationGrids/${id}`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const reorderRecommendationGrids = grids => {
  return new Promise((resolve, reject) => {
    APIClient.post('RecommendationGrids/reorder', { grids })
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};
